import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  findReportWidgetsForBreakdownCategory,
  widgetBreakdownChipItems,
} from "util/aiReportWidgetBreakdown";
import styles from "./AiReportWidgetBreakdownChips.module.scss";

export function AiReportWidgetBreakdownChips({
  report,
  widgets = null,
  showLabel = true,
  className,
  labelClassName,
  onChipNavigate = null,
}) {
  const { t } = useTranslation();
  const chips = useMemo(() => widgetBreakdownChipItems(report, t), [report, t]);
  const widgetRows = widgets ?? report?.widgets ?? [];

  if (!report?.widgets_total || chips.length === 0) {
    return null;
  }

  const handleChipClick = (chip) => {
    if (typeof onChipNavigate !== "function") return;
    const matches = findReportWidgetsForBreakdownCategory(widgetRows, chip.key);
    if (!matches.length) return;
    onChipNavigate(chip.key, matches[0]);
  };

  return (
    <div className={[styles.row, className].filter(Boolean).join(" ")}>
      {showLabel ? (
        <span className={[styles.label, labelClassName].filter(Boolean).join(" ")}>
          {t("ai_services.widgets_progress_label")}:
        </span>
      ) : null}
      <div className={styles.chips}>
        {chips.map((chip) => {
          const navigable =
            typeof onChipNavigate === "function" &&
            findReportWidgetsForBreakdownCategory(widgetRows, chip.key).length > 0;
          if (navigable) {
            return (
              <button
                key={chip.key}
                type="button"
                className={`${styles.chip} ${styles[`chip_${chip.tone}`]} ${styles.chipButton}`}
                onClick={() => handleChipClick(chip)}
              >
                {chip.label}
              </button>
            );
          }
          return (
            <span
              key={chip.key}
              className={`${styles.chip} ${styles[`chip_${chip.tone}`]}`}
            >
              {chip.label}
            </span>
          );
        })}
      </div>
    </div>
  );
}
